import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://nyyqgmpwmcrlxydjwecz.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im55eXFnbXB3bWNybHh5ZGp3ZWN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE0NjE2ODAsImV4cCI6MjA4NzAzNzY4MH0.KXRDpIHqHtUlDKUq6zluNrYP04FUx6bSj_uoGqFrPvI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
